import axiosInstance from './Instance/axiosInstance';

export const login = async (username: string, password: string) => {
    const response = await axiosInstance.post('/auth/login', { name: username, password });
    return response.data;
};

export const getMe = async () => {
    const response = await axiosInstance.get('/me');
    return response.data;
};


export const logout = async () => {
    const response = await axiosInstance.post('/auth/logout');
    return response.data.message;
};